import { Injectable, Injector } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { APP_CONFIG, ConfigManager, IAppConfig } from '@app/core';
import { PartialUrl } from 'src/app/core/enums/partial-url.enum';

type IsCitizenType = Observable<boolean | UrlTree> | boolean | UrlTree;

/**
 * Is citizen Guard
 */
@Injectable()
export class IsCitizenGuard {
	/**
	 * Controls if the user is CAISS
	 */
	private readonly _isCaiss: any;

	/**
	 * Is citizen guard constructor
	 *
	 * @param _store store
	 * @param _router router
	 * @param _injector injector
	 */
	constructor(
		private _router: Router,
		_injector: Injector,
	) {
		const appConfig: IAppConfig = _injector.get<ConfigManager>(APP_CONFIG).config;
		this._isCaiss = appConfig.caiss === 1;
	}

	/**
	 * Checks if the user can activate children
	 *
	 * @returns true if the user can active children
	 */
	canActivateChild(): IsCitizenType {
		return this._isCitizen();
	}

	/**
	 * Checks if the user can activate an element or event
	 *
	 * @returns true if the user can active it
	 */
	canActivate(): IsCitizenType {
		return this._isCitizen();
	}

	/**
	 * Checks if the user can load an element or event
	 *
	 * @returns true if the user can load it
	 */
	canLoad(): IsCitizenType {
		return this._isCitizen();
	}

	/**
	 * Checks if the user is a citizen or CAISS
	 *
	 * @returns true if the user is a citizen or redirects to the home page if the user is CAISS
	 */
	private _isCitizen(): IsCitizenType {
		if (this._isCaiss) {
			return this._router.parseUrl(PartialUrl.HOME);
		} else {
			return true;
		}
	}
}
